module.exports = __webpack_public_path__ + "static/media/left-arrow.b86224b1.svg";